import { useT } from "@magic-md/i18n/react";
import { FileVideo, Music } from "lucide-react";
import { getPlatformService } from "../../platform";

interface MediaPreviewProps {
    filePath?: string;
    kind: "audio" | "video";
}

export function MediaPreview({ filePath, kind }: MediaPreviewProps) {
    const t = useT("editor");
    const url = filePath ? getPlatformService().getAssetUrl?.(filePath) : undefined;

    if (!filePath || !url) {
        const Icon = kind === "audio" ? Music : FileVideo;
        return (
            <div className="h-full flex flex-col items-center justify-center gap-1 text-muted-foreground">
                <Icon size={24} className="opacity-50" />
                <div className="text-[12px]">
                    {filePath ? t("preview.unsupportedMedia") : t("preview.noFilePath")}
                </div>
                {filePath && (
                    <div className="text-[10px] opacity-70">{t("preview.openInDesktop")}</div>
                )}
            </div>
        );
    }

    return (
        <div className="h-full w-full flex flex-col bg-background">
            <div className="flex items-center justify-between px-3 py-1.5 border-b border-border bg-muted/40">
                <span className="text-[11px] font-medium">
                    {kind === "audio" ? t("preview.audio") : t("preview.video")}
                </span>
                <span className="text-[10px] font-mono text-muted-foreground truncate max-w-[60%]">
                    {filePath.split(/[/\\]/).pop()}
                </span>
            </div>
            <div className="flex-1 flex items-center justify-center p-4 overflow-auto">
                {kind === "audio" ? (
                    <audio src={url} controls className="w-full max-w-md" />
                ) : (
                    <video
                        src={url}
                        controls
                        className="max-w-full max-h-full"
                        preload="metadata"
                    />
                )}
            </div>
        </div>
    );
}
